module.exports = __webpack_public_path__ + "img/no product icon.7ad0ebd1.svg";